/* tslint:disable */
/* eslint-disable */
/**
 * Melco Reporting APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportingMelcoMachineStatisticsModelsMachineListItem,
    ReportingMelcoMachineStatisticsModelsMachineListItemFromJSON,
    ReportingMelcoMachineStatisticsModelsMachineListItemFromJSONTyped,
    ReportingMelcoMachineStatisticsModelsMachineListItemToJSON,
    ReportingMelcoModelsCustomWarning,
    ReportingMelcoModelsCustomWarningFromJSON,
    ReportingMelcoModelsCustomWarningFromJSONTyped,
    ReportingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem
 */
export interface ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem {
    /**
     * 
     * @type {Array<ReportingMelcoMachineStatisticsModelsMachineListItem>}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem
     */
    list: Array<ReportingMelcoMachineStatisticsModelsMachineListItem>;
    /**
     * 
     * @type {Array<ReportingMelcoModelsCustomWarning>}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem
     */
    warning_list?: Array<ReportingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem
     */
    total: number;
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItemFromJSON(json: any): ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem {
    return ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItemFromJSONTyped(json, false);
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ReportingMelcoMachineStatisticsModelsMachineListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ReportingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItemToJSON(value?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsMachineListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ReportingMelcoMachineStatisticsModelsMachineListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ReportingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


